import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  LoggingService,
  OSType,
  TimePeriod,
} from "app/shared";
import { BaseDetailsLogic } from "app/analytics/BaseDetailsLogic";
import { AppVersionConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { TooltipCoordinatorService } from "app/analytics/services/tooltip-coordinator.service";

@Component({
  selector: "app-version-details",
  templateUrl: "./app-version-details.component.html",
  standalone: false,
})
export class AppVersionDetailsComponent
  extends BaseDetailsLogic<AppVersionConfig>
  implements OnInit, OnDestroy
{
  constructor(
    analyticsService: AnalyticsService,
    authService: AuthorizationService,
    loggingService: LoggingService,
    tooltipCoordinator: TooltipCoordinatorService
  ) {
    super(analyticsService, authService, loggingService, AppVersionConfig, tooltipCoordinator);
  }

  get selectedTimePeriod(): string | TimePeriod {
    return this.config?.period as TimePeriod;
  }

  set selectedTimePeriod(value: string | TimePeriod) {
    this.config.period = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  get selectedOSType(): string | OSType {
    return this.config?.osType as OSType;
  }

  set selectedOSType(value: string | OSType) {
    this.config.osType = value;
    this.detectSettingsChange();
    this.refreshDataFromFilters();
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }

  protected getInfoTexts(): { [key: string]: string } {
    return {
      timePeriod:
        "Pick a time period to see app version data for that range. For example, you can look at results from the last week, month, or year. This helps you understand when different app versions were used.",
      osType:
        "Choose which operating system you want to see data for. For example, you can select Windows, Android, or IOS to focus on users with that system.",
    };
  }
}
